import { createContext } from 'react';

import { WebsocketContextProps } from './WebsocketContext.types';

export const WebsocketContext = createContext<WebsocketContextProps>(undefined);
